import styled from '@emotion/styled';

const StyledRegionContainer = styled.div``;

export default StyledRegionContainer;
